import React, { useState, useEffect, useCallback } from "react";
import { NavLink } from "react-router-dom";

import { makeStyles } from "@material-ui/core";

import Particles from "react-particles";
import { loadFull } from "tsparticles";

import MenuDropdown from "./MenuDropdown";
import WalletDropdown from "./WalletDropdown";
import NetworkDropdown from "./NetworkDropdown";

import { getOwner } from "../Staking/StackingFunctions";

import { MenuItems } from "./MenuItems";

import * as chains from "../constants/chains";

import "./NavBar.scss";
import {
  getPartnerWallet,
  getTotalPartners,
} from "../Withdraw/WithdrawFunctions";

const useStyles = makeStyles((theme) => ({
  navMenu: {
    backgroundColor: theme.palette.background.paper,
  },
  navLinks: {
    color: `${theme.palette.text.primary} !important`,
    "&.active": {
      backgroundColor: theme.palette.background.default,
    },
  },
}));

function NavBar({ network, darkMode, onChange }) {
  const configs = require("../configs.json");
  const classes = useStyles();

  const [isAdmin, setIsAdmin] = useState(false);
  const [isPartner, setIsPartner] = useState(false);
  const [selectedNetwork, setSelectedNetwork] = useState({
    chainName: null,
    symbol: null,
  });

  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    await console.log(container);
  }, []);

  const get_owner = () => {
    getOwner(network.stacking, network.signer).then((res) => {
      if (res.toLowerCase() === network.account) {
        setIsAdmin(true);
      }
    });
  };

  const get_partners = async () => {
    let total_partners = await getTotalPartners(
      network.withdraw,
      network.signer
    );

    if (total_partners) {
      let partners_array = [];

      for (let i = 0; i < total_partners; i++) {
        const index = i;
        await getPartnerWallet(network.withdraw, network.signer, index).then(
          (res) => {
            partners_array.push(res);
          }
        );
      }

      for (let i = 0; i < partners_array.length; i++) {
        const partner = partners_array[i];
        if (partner.toLowerCase() === network.account) {
          setIsPartner(true);
          break;
        }
      }
    }
  };

  const set_selected_network = () => {
    for (const [key, value] of Object.entries(chains.chainConfigs)) {
      if (value.chainId == network.chainID) {
        let selected = { ...selectedNetwork };
        selected.chainName = value.chainName;
        selected.symbol = value.nativeCurrency.symbol;
        setSelectedNetwork(selected);
      }
    }
  };

  useEffect(() => {
    const navbarTimeout = setTimeout(() => {
      get_owner();
      get_partners();
      set_selected_network();
    }, 2000);

    return () => clearTimeout(navbarTimeout);
  }, [network]);

  return (
    <header className="main-header">
      <img
        src={
          darkMode && configs.theme.logo.mainLogoLight
            ? configs.theme.logo.mainLogoLight
            : configs.theme.logo.mainLogo
        }
        alt="logo"
        className="logo d-none d-md-block"
      />

      <img
        src={
          darkMode && configs.theme.logo.smallLogoLight
            ? configs.theme.logo.smallLogoLight
            : configs.theme.logo.smallLogo
        }
        alt="logo"
        className="logo d-block d-md-none"
      />

      <ul className={`nav-menu ${classes.navMenu}`}>
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
              <NavLink
                activeclassname="active"
                className={`nav-links ${classes.navLinks}`}
                to={item.url}
              >
                {item.title}
              </NavLink>
            </li>
          );
        })}
        <MenuDropdown isAdmin={isAdmin} isPartner={isPartner} />
      </ul>

      <div className="d-flex align-items-center justify-content-end gap-1">
        <NetworkDropdown selectedNetwork={selectedNetwork} />

        <WalletDropdown
          network={network}
          darkMode={darkMode}
          onChange={onChange}
        />
      </div>

      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        height="78px"
        options={configs.theme.particle}
      />
    </header>
  );
}

export default NavBar;
